/** enums */

import { t } from 'i18next';
import { QueryDateType } from 'models/unit';
import { CHEATTYPE, CHEATTYPENAME } from 'pages/situationManagement/cheatConfig/CONST';

export enum IDimensions {
  COACH = 'COACH', // 辅导氛围
  SITUATION = 'SITUATION', // 讨论现状
  SOLUTION = 'SOLUTION', // 共创行动
  SOURCE = 'SOURCE', // 发现机会
  SUCCESS = 'SUCCESS' // 共识目标
}
export enum EnumDimensionsLevel {
  LEVEL1 = 'LEVEL1',
  LEVEL2 = 'LEVEL2'
}
export enum EnumUserStatus {
  NORMAL = 'NORMAL',
  RESIGNED = 'RESIGNED'
}
export enum EnumRecordTag {
  NONE = 'NONE',
  //  他评
  ASSESS_QUESTIONNAIRE = 'ASSESS_QUESTIONNAIRE',
  // 人工评分
  MANUAL_SCORING = 'MANUAL_SCORING'
}
export const TAG_STATUS_TEXT = {
  [EnumRecordTag.NONE]: '-',
  [EnumRecordTag.ASSESS_QUESTIONNAIRE]: '他评',
  [EnumRecordTag.MANUAL_SCORING]: '人工'
};

export enum EnumValidStatus {
  VALID = 'VALID',
  INVALID = 'INVALID'
}

export enum SearchTaskStatus {
  RUNNING = 'IN_PROGRESS',
  FAILED = 'FAILED',
  COMPLETE = 'COMPLETED'
}

export enum QueryTimeRuleType {
  BEHAVIOR_TIME = 'ACT_TIME',
  NORMAL_TIME = 'NATURAL_TIME'
}

export enum CompareType {
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = ' LESS_THAN',
  EQUAL_TO = ' EQUAL_TO'
}

export enum EnumTypeName {
  userInfoExportFields = 'userInfoExportFields',
  practiceInfoExportFields = 'practiceInfoExportFields',
  reportInfoExportFields = 'reportInfoExportFields',
  exceptionInfoExportFields = 'exceptionInfoExportFields'
}

/** constants */
export const getMapTypeName: any = () => {
  return {
    [EnumTypeName.userInfoExportFields]: '个人信息',
    [EnumTypeName.practiceInfoExportFields]: `${t('global.practice')}概况`,
    [EnumTypeName.reportInfoExportFields]: '报告详情',
    [EnumTypeName.exceptionInfoExportFields]: '异常信息'
  };
};

/** response data */
export interface IListQuery {
  userName?: string;
  employeeNo?: string;
  orgChainId?: string;
  groupName?: string;
  unitName?: string;
  pageNo: number;
  pageSize: number;
  sorts?: ISort[];
  identificationId?: any;
  userType?: any;
}

export interface ISort {
  sortBy: string;
  sortOrder: string; // desc asc
}

export interface IUserQuery {
  userId: string;
  unitId: string;
  pageNo: number;
  pageSize: number;
  submitStartTime?: number;
  submitEndTime?: number;
  sorts?: ISort[];
  validStatus?: string; //有效/无效状态
}

export interface IDownload {
  userId: string;
  unitId: string;
}

//  评估记录高级查询任务
export interface AdvancedSearchTaskParam {
  id?: number;
  createAt?: string;
  status?: string;
  //  以上三个不传
  name?: string;
  unitIds?: string[];
  //  回显陪练组用到的字段
  unitKey?: string;
  //  时间规则（行为时间or自然日）
  dateRule?: QueryTimeRuleType;
  //  行为时间 类型
  dateScopeType?: QueryDateType;
  //  自然日时间--开始
  queryStartTime?: number;
  //  自然日时间--结束
  queryEndTime?: number;
  //  行为规则
  practiceCountCompareType: CompareType;
  practiceCountThreshold: number;
  maxScoreCompareType: CompareType;
  maxScoreThreshold: number;
  //  邮件是否自动发送
  sendEmailSwitch?: boolean;
  //  邮件发送周期
  dateCycleType?: string;
  //  邮件发送地址
  emails?: string;
  //  邮件发送时间
  sendEmailEndTime?: string;
  sendEmailStartTime?: string;
  exportFieldConfigBO: any;
}
export interface IKeysListItem {
  code: string;
  codeName: string;
  effect: boolean;
}

export interface IExportField {
  key: string;
  name: string;
  options: IKeysListItem[];
  checkedList: string[];
  checkAll: boolean;
  indeterminate: boolean;
}
export interface IExportkeys {
  [EnumTypeName.userInfoExportFields]?: IKeysListItem[];
  [EnumTypeName.practiceInfoExportFields]?: IKeysListItem[];
  [EnumTypeName.reportInfoExportFields]?: IKeysListItem[];
  [EnumTypeName.exceptionInfoExportFields]?: IKeysListItem[];
  [key: string]: any;
}

export enum EnumPracticeScoreStatus {
  UN_SCORE = 'UN_SCORE',
  SCORE_FAIL = 'SCORE_FAIL',
  SCORED = 'SCORED'
}

/** 报告状态 wait：评分中；ing：报告生成中； ready：报告生成完成； failed：报告生成失败 */
export enum EnumReportStatus {
  ing = 'ing',
  ready = 'ready',
  failed = 'failed'
}

export const PRACTICE_SCORE_STATUS_OPTIONS = [
  {
    value: EnumReportStatus.ing,
    label: '评估中'
  },
  {
    value: EnumReportStatus.ready,
    label: '已完成'
  },
  {
    value: EnumReportStatus.failed,
    label: '生成失败'
  }
];

// 练习记录 是否有异常 条件筛选
export const ERROR_TYPES = [
  {
    value: CHEATTYPE.CONTENT_REPEAT,
    label: CHEATTYPENAME[CHEATTYPE.CONTENT_REPEAT]
  },
  {
    value: CHEATTYPE.FEATURE_ERROR_OF_AUDIO,
    label: CHEATTYPENAME[CHEATTYPE.FEATURE_ERROR_OF_AUDIO]
  },
  {
    value: CHEATTYPE.NONE_PERSON,
    label: CHEATTYPENAME[CHEATTYPE.NONE_PERSON]
  },
  {
    value: CHEATTYPE.MULTI_PERSON,
    label: CHEATTYPENAME[CHEATTYPE.MULTI_PERSON]
  },
  {
    value: CHEATTYPE.CHANGE_PERSON,
    label: CHEATTYPENAME[CHEATTYPE.CHANGE_PERSON]
  },
  {
    value: CHEATTYPE.VIDEO_QUALITY_TOO_LOW,
    label: '视频质量未达标' // ，不进行画面内容分析
  },
  {
    value: CHEATTYPE.OPEN_EYES,
    label: CHEATTYPENAME[CHEATTYPE.OPEN_EYES]
  },
  {
    value: CHEATTYPE.ONE_PLAY_TWO_ROLE,
    label: CHEATTYPENAME[CHEATTYPE.ONE_PLAY_TWO_ROLE]
  },
  {
    value: CHEATTYPE.LANGUAGE_RESTRICT,
    label: CHEATTYPENAME[CHEATTYPE.LANGUAGE_RESTRICT]
  },
  {
    value: CHEATTYPE.EFFECT_ANSWER,
    label: CHEATTYPENAME[CHEATTYPE.EFFECT_ANSWER]
  },
  {
    value: CHEATTYPE.NOT_COMPLIANT,
    label: CHEATTYPENAME[CHEATTYPE.NOT_COMPLIANT]
  },
  {
    value: CHEATTYPE.NOT_OPEN_MOUTH,
    label: '未张嘴作答'
  },
  {
    value: CHEATTYPE.SCREEN_SHOT,
    label: CHEATTYPENAME[CHEATTYPE.SCREEN_SHOT]
  },
  {
    value: CHEATTYPE.LEAVE,
    label: CHEATTYPENAME[CHEATTYPE.LEAVE]
  }
];
// 考试记录 是否有异常 条件筛选
export const ERROR_TYPES_EXAM = [
  {
    value: CHEATTYPE.CONTENT_REPEAT,
    label: CHEATTYPENAME[CHEATTYPE.CONTENT_REPEAT]
  },
  {
    value: CHEATTYPE.FEATURE_ERROR_OF_AUDIO,
    label: CHEATTYPENAME[CHEATTYPE.FEATURE_ERROR_OF_AUDIO]
  },
  {
    value: CHEATTYPE.LEAVE,
    label: CHEATTYPENAME[CHEATTYPE.LEAVE]
  },
  {
    value: CHEATTYPE.SCREEN_SHOT,
    label: CHEATTYPENAME[CHEATTYPE.SCREEN_SHOT]
  },
  {
    value: CHEATTYPE.NONE_PERSON,
    label: CHEATTYPENAME[CHEATTYPE.NONE_PERSON]
  },
  {
    value: CHEATTYPE.MULTI_PERSON,
    label: CHEATTYPENAME[CHEATTYPE.MULTI_PERSON]
  },
  {
    value: CHEATTYPE.CHANGE_PERSON,
    label: CHEATTYPENAME[CHEATTYPE.CHANGE_PERSON]
  },
  {
    value: CHEATTYPE.VIDEO_QUALITY_TOO_LOW,
    label: '视频质量未达标' //，不进行画面内容分析
  },
  {
    value: CHEATTYPE.OPEN_EYES,
    label: CHEATTYPENAME[CHEATTYPE.OPEN_EYES]
  },
  {
    value: CHEATTYPE.ONE_PLAY_TWO_ROLE,
    label: CHEATTYPENAME[CHEATTYPE.ONE_PLAY_TWO_ROLE]
  },
  {
    value: CHEATTYPE.NOT_COMPLIANT,
    label: CHEATTYPENAME[CHEATTYPE.NOT_COMPLIANT]
  },
  {
    value: CHEATTYPE.LANGUAGE_RESTRICT,
    label: CHEATTYPENAME[CHEATTYPE.LANGUAGE_RESTRICT]
  },
  {
    value: CHEATTYPE.NOT_OPEN_MOUTH,
    label: '未张嘴作答'
  }
  // {
  //   value: CHEATTYPE.SCREEN_SHOT,
  //   label: CHEATTYPENAME[CHEATTYPE.SCREEN_SHOT]
  // },
  // {
  //   value: CHEATTYPE.LEAVE,
  //   label: CHEATTYPENAME[CHEATTYPE.LEAVE]
  // }
];
